/*
 * START_MODULE_CONTRACT
 *   PURPOSE: Loading placeholder with 4 shape presets using CSS shimmer animation
 *   PROPS:   variant (text|card|button|circular) + all native div attributes
 *   STATE:   none
 *   DEPENDS: M-CN (cn utility)
 *   EMITS:   none
 *   ACCESSIBILITY: aria-hidden="true" by default — decorative loading indicator
 *   LINKS:   M-SKL
 * END_MODULE_CONTRACT
 *
 * CHANGE_SUMMARY
 *   [2026-06-12] Added GRACE MODULE_CONTRACT and semantic blocks — no behavior change
 */

import { forwardRef } from "react"
import { cn } from "@/lib/cn"

// --- TypeDefinitions ---
interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "text" | "card" | "button" | "circular"
}

// --- ShapePresets ---
const variantClasses = {
  text: "h-4 w-full rounded-sm",
  card: "h-32 w-full rounded-xl",
  button: "h-10 w-24 rounded-md",
  circular: "h-10 w-10 rounded-full",
} as const

// --- SkeletonComponent ---
const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant = "text", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("skeleton-shimmer", variantClasses[variant], className)}
        aria-hidden="true"
        {...props}
      />
    )
  },
)
Skeleton.displayName = "Skeleton"

export { Skeleton }
export type { SkeletonProps }
